import React from 'react';
import SEO from '../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './SaaS.css';

const SaaS = () => {
    return (
        <div className="industry-page">
            <SEO 
                title="Saa S Services | Digi Network" 
                description="Learn more about our Saa S services to grow your business online with Digi Network." 
                canonical="/industries/saas/saas" 
            />

            <section className="industry-hero">
                <div className="industry-hero-bg"></div>
                <div className="container">
                    <div className="industry-hero-content">
                        <div className="label">SaaS Industry</div>
                        <h1>Digital Marketing for SaaS Companies</h1>
                        <p>Drive trial sign-ups, reduce churn, and scale your SaaS business with data-driven marketing strategies designed for software companies. We understand the unique challenges SaaS businesses face in today's competitive software market.</p>
                        <div className="industry-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                                Get Started
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </Link>
                            <Link to="/case-studies" className="btn btn-outline">View Results</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="hero-image-section">
                <div className="container">
                    <div className="image-placeholder-large">
                        <p>📷 Add SaaS Hero Image (1200x500px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-services">
                <div className="container">
                    <h2>SaaS Marketing Services</h2>
                    <p className="section-intro">Comprehensive marketing solutions tailored for software companies</p>
                    <div className="services-grid">
                        <div className="service-card">
                            <h3>SaaS SEO</h3>
                            <p>Rank for software keywords, build authority, and drive organic traffic that converts into trials and sign-ups. Our SaaS SEO strategies help software companies dominate search results for relevant product keywords.</p>
                            <ul>
                                <li>Technical SEO for SaaS platforms</li>
                                <li>Content marketing for software</li>
                                <li>Competitor keyword analysis</li>
                                <li>Product page optimization</li>
                                <li>Blog content strategy</li>
                                <li>Link building campaigns</li>
                            </ul>
                            <Link to="/industries/saas/seo" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>SaaS Paid Ads</h3>
                            <p>Drive qualified trials and sign-ups with targeted advertising campaigns across all platforms. Our targeted ad campaigns reach decision-makers actively searching for software solutions.</p>
                            <ul>
                                <li>Google Ads for SaaS</li>
                                <li>LinkedIn B2B advertising</li>
                                <li>Facebook & Instagram ads</li>
                                <li>Retargeting campaigns</li>
                                <li>YouTube video ads</li>
                                <li>Conversion tracking & optimization</li>
                            </ul>
                            <Link to="/industries/saas/paid-ads" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>SaaS Website Development</h3>
                            <p>High-converting landing pages, product websites, and onboarding experiences that drive conversions. Our SaaS websites are designed to showcase your product and convert visitors into trial users.</p>
                            <ul>
                                <li>Landing page optimization</li>
                                <li>Product demo pages</li>
                                <li>Pricing page design</li>
                                <li>Conversion rate optimization</li>
                                <li>Mobile-responsive design</li>
                                <li>Integration documentation</li>
                            </ul>
                            <Link to="/industries/saas/web-development" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>SaaS Email Marketing</h3>
                            <p>Onboard users, reduce churn, and drive engagement with automated email sequences. Build lasting relationships with users through strategic email communication that provides value.</p>
                            <ul>
                                <li>Welcome & onboarding sequences</li>
                                <li>Feature announcement emails</li>
                                <li>Churn prevention campaigns</li>
                                <li>Product update newsletters</li>
                                <li>User engagement campaigns</li>
                                <li>Win-back sequences</li>
                            </ul>
                            <Link to="/industries/saas/email-marketing" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>SaaS CRM & Automation</h3>
                            <p>Automate user journeys, manage leads, and track conversions with GoHighLevel for SaaS. Streamline your sales and marketing operations with automated workflows that scale.</p>
                            <ul>
                                <li>Lead scoring & qualification</li>
                                <li>Trial to paid conversion</li>
                                <li>User behavior tracking</li>
                                <li>Revenue attribution</li>
                                <li>Churn prediction & prevention</li>
                                <li>Customer success automation</li>
                            </ul>
                            <Link to="/industries/saas/all-in-one" className="service-link">Learn More →</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="process-section">
                <div className="container">
                    <h2 className="process-item-title">Our SaaS Marketing Process</h2>
                    <p className="section-intro">A proven methodology designed specifically for software companies</p>
                    <div className="process-grid">
                        <div className="process-item">
                            <div className="process-number">1</div>
                            <h3>Product & Market Analysis</h3>
                            <p>We analyze your SaaS product, target market, and competitive landscape to understand your unique positioning. Our team conducts comprehensive audits of your current marketing and user acquisition strategies.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">2</div>
                            <h3>Growth-Focused Strategy</h3>
                            <p>We develop a customized marketing strategy that focuses on driving MRR growth, reducing CAC, and improving LTV. Every tactic is designed to maximize trial sign-ups and paid conversions.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">3</div>
                            <h3>Multi-Channel Implementation</h3>
                            <p>We implement the marketing strategy across all channels, from content marketing to paid ads to email. Our team handles everything from landing page optimization to ad campaign launches.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">4</div>
                            <h3>Optimization & Scaling</h3>
                            <p>We continuously monitor performance, analyze user data, and optimize campaigns for better results. Regular reporting keeps you informed of your CAC, LTV, and MRR growth metrics.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add SaaS Process Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="why-choose">
                <div className="container">
                    <h2>Why SaaS Companies Choose Digi Network</h2>
                    <p className="why-intro">Trusted by software companies across the UAE and internationally</p>
                    <div className="why-grid">
                        <div className="why-item">
                            <div className="why-number">01</div>
                            <h3>Growth-Focused</h3>
                            <p>Every strategy is designed to drive MRR growth, reduce CAC, and improve LTV. We understand that SaaS success is measured in recurring revenue, not just website traffic.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">02</div>
                            <h3>SaaS Expertise</h3>
                            <p>We understand the SaaS business model and create campaigns that drive trial sign-ups and conversions. Our team has extensive experience working with B2B and B2C software companies.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">03</div>
                            <h3>Data-Driven Approach</h3>
                            <p>We track every metric that matters: CAC, LTV, churn rate, and MRR growth. Our data-driven approach ensures you make informed decisions about your marketing spend.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">04</div>
                            <h3>Proven Results</h3>
                            <p>We've helped SaaS companies increase trial sign-ups by 350%+ and reduce CAC by 40%. Our data-driven approach delivers measurable results that directly impact your bottom line.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="benefits-section">
                <div className="container">
                    <h2 className="benefits-title">Key Benefits for SaaS Companies</h2>
                    <p className="section-intro">How our marketing services help you scale your SaaS business</p>
                    <div className="benefits-grid">
                        <div className="benefit-item">
                            <h3>More Trial Sign-Ups</h3>
                            <p>Generate a steady stream of qualified trial sign-ups through targeted marketing campaigns. Our strategies focus on converting interested prospects into active trial users.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Higher Conversion Rates</h3>
                            <p>Optimize your onboarding process and conversion funnels to turn more trials into paid customers. Our conversion rate optimization strategies help you maximize every sign-up.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Lower Churn</h3>
                            <p>Reduce churn through automated engagement campaigns and personalized communication. Keep users active and engaged with strategic retention strategies.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Better User Onboarding</h3>
                            <p>Improve user onboarding with automated email sequences and in-app guidance. Help new users understand your product and achieve their first success quickly.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Higher MRR Growth</h3>
                            <p>Grow your monthly recurring revenue through more sign-ups, better conversions, and lower churn. Our strategies help you build a sustainable, growing SaaS business.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Competitive Advantage</h3>
                            <p>Stay ahead of competitors with cutting-edge marketing strategies and technology. Many SaaS companies still rely on basic marketing methods like content marketing alone.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add SaaS Benefits Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-cta">
                <div className="container">
                    <h2 className="process-item-title">Ready to Scale Your SaaS Business?</h2>
                    <p>Let's discuss how we can help you drive more trials, reduce churn, and grow your MRR.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Book a Free Consultation
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default SaaS;
